<div class="card">
  <h5 class="page-title">Delivery Fee Ledger</h5>

  <div *ngIf="featureDisabled" class="feature-disabled">
    TinyAll Delivery Network is not enabled on this environment
    (set <code>TINYALL_DELIVERY_NETWORK_ENABLED=true</code> on the backend).
  </div>

  <div class="toolbar">
    <label>
      Status:
      <select [(ngModel)]="statusFilter" (change)="loadData()">
        <option *ngFor="let s of statusOptions" [value]="s">{{ s || 'All' }}</option>
      </select>
    </label>
    <label>
      Hub ID:
      <input type="text" [(ngModel)]="hubFilter" placeholder="filter by hub id" />
    </label>
    <button pButton type="button" icon="pi pi-search" label="Apply"
            class="p-button-sm" (click)="loadData()"></button>
    <button pButton type="button" icon="pi pi-refresh" label="Refresh"
            class="p-button-sm p-button-secondary" (click)="loadData()"></button>
  </div>

  <p-table
    [value]="data"
    dataKey="id"
    [rows]="20"
    [paginator]="true"
    [rowsPerPageOptions]="[20,40,80]"
    [loading]="isLoading"
    styleClass="p-datatable-customers p-datatable-gridlines"
    [autoLayout]="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Created</th>
        <th>Hub</th>
        <th>Order</th>
        <th>Assignment</th>
        <th>Network Fee</th>
        <th>Status</th>
        <th>Period</th>
        <th>Delivered</th>
        <th class="actions-col">Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td>{{ item.createdOn | date: 'short' }}</td>
        <td>{{ item.hubId }}</td>
        <td>{{ item.orderId }}<br /><small>{{ item.orderSourceType }}</small></td>
        <td>{{ item.assignmentId }}</td>
        <td>{{ item.feeAmount }}</td>
        <td><span class="status-tag" [ngClass]="statusSeverity(item.status)">{{ item.status }}</span></td>
        <td>{{ item.weekBucket }}</td>
        <td>{{ item.deliveredAt | date: 'short' }}</td>
        <td class="actions-col">
          <button pButton type="button" label="Charge" class="p-button-sm p-button-success p-mr-1"
                  *ngIf="item.status !== 'CHARGED'"
                  (click)="confirmSetStatus(item, 'CHARGED')"></button>
          <button pButton type="button" label="Waive" class="p-button-sm p-button-warning p-mr-1"
                  *ngIf="item.status !== 'WAIVED'"
                  (click)="confirmSetStatus(item, 'WAIVED')"></button>
          <button pButton type="button" label="Review" class="p-button-sm p-button-secondary"
                  *ngIf="item.status !== 'REVIEW'"
                  (click)="confirmSetStatus(item, 'REVIEW')"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr><td colspan="9">No fee ledger rows found.</td></tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
